import apiClient from '../api/apiClient';
import { LdapAuthRequest, LdapAuthResponse } from '../../types/auth';

class LdapAuthService {
  // TODO: Remove hardcoded value once backend sends timeout configuration
  private static readonly API_TIMEOUT = 10000; // 10 seconds

  static async authenticate(username: string, password: string, sessionId: string): Promise<LdapAuthResponse> {
    try {
      const request: LdapAuthRequest = {
        password: password
      };

      const response = await apiClient.post<LdapAuthResponse>(
        `/auth/ad/authenticate?sessionId=${sessionId}`,
        request,
        {
          headers: {
            'Content-Type': 'application/json',
          },
          timeout: this.API_TIMEOUT
        }
      );

      // Clear sensitive data from memory
      password = '';
      
      return response.data;

    } catch (error: any) {
      if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
        return {
          success: false,
          authoritativeOU: null,
          sessionId: null,
          message: 'Authentication request timed out. Please try again.',
          accountLocked: false,
          badPwdCount: null,
          requireMFA: false,
          sydneyUser: false
        };
      }
      
      return {
        success: false,
        authoritativeOU: null,
        sessionId: null,
        message: 'Unable to connect to authentication service. Please check your network connection.',
        accountLocked: false,
        badPwdCount: null,
        requireMFA: false,
        sydneyUser: false
      };
    }

  }
}

export default LdapAuthService;
